import { useEffect, useRef, useState } from 'react';
import { elapsedSeconds } from '../utils/time';

export function useTimer(startTime, running = true, offsetSeconds = 0) {
  const [elapsed, setElapsed] = useState(() =>
    startTime ? Math.max(0, elapsedSeconds(startTime) - offsetSeconds) : 0
  );
  const ref = useRef(null);

  useEffect(() => {
    if (!running || !startTime) {
      clearInterval(ref.current);
      return;
    }
    const tick = () => setElapsed(Math.max(0, elapsedSeconds(startTime) - offsetSeconds));
    tick();
    ref.current = setInterval(tick, 1000);
    return () => clearInterval(ref.current);
  }, [startTime, running, offsetSeconds]);

  return elapsed;
}
